module.exports = __webpack_public_path__ + "img/92.0f6009cf.jpg";